<template>
  <v-container v-if="$can('browse', 'CurrencyExchangeRate')">
    <v-row
      no-gutters
      justify="center"
    >
      <v-col xl="12">
        <div class="headline mb-12">
          Currency Exchange Rates
        </div>

        <v-row>
          <v-col
            cols="3"
          >
            <v-subheader class="justify-space-between pr-0">
              Filters
              <v-btn
                v-if="isFiltered"
                text
                color="red"
                @click="clearFilters"
              >
                <v-icon
                  small
                  left
                >
                  close
                </v-icon>
                Clear
              </v-btn>
            </v-subheader>
            <v-select
              v-model="filtersDirty.base"
              :items="currencies"
              label="Base Currency"
              class="mb-2"
              hide-details
              solo
              clearable
            />
            <v-select
              v-model="filtersDirty.quote"
              :items="currencies"
              label="Quote Currency"
              hide-details
              solo
              clearable
            />
          </v-col>
          <v-col cols="13">
            <v-data-table
              :headers="currencyExchangeHeaders"
              :items="currencyExchangeRates.data"
              :server-items-length="currencyExchangeRates.data.length"
              hide-default-footer
              class="elevation-5"
            >
              <template v-slot:item="{ item }">
                <currency-exchange-rate-row
                  :currency-exchange-rate="item"
                  :year="nextYear"
                  :margin-rates="currencyExchangeMarginRates.data"
                />
              </template>
              <template slot="no-data">
                <!--<editor-fold desc="Loader">-->
                <v-row
                  v-if="currencyExchangeRates.loading"
                  class="justify-center align-center pa-6"
                >
                  <v-col
                    class="pa-6 shrink"
                  >
                    <v-progress-circular
                      :size="50"
                      :width="4"
                      indeterminate
                    />
                  </v-col>
                </v-row>
                <!--</editor-fold>-->
                <!--<editor-fold desc="Filtered">-->
                <v-row
                  v-else-if="isFiltered"

                  class="text-center py-2"
                >
                  <v-col cols="16">
                    There are no results for your search..
                  </v-col>
                  <v-col
                    cols="16"
                    class="mt-2"
                  >
                    <v-btn
                      class="ma-0"
                      small
                      text
                      @click="clearFilters()"
                    >
                      <v-icon left>
                        clear
                      </v-icon>
                      Clear Filters
                    </v-btn>
                  </v-col>
                </v-row>
                <!--</editor-fold>-->
                <!--<editor-fold desc="NoData">-->
                <div
                  v-else
                  class="text-center py-2"
                >
                  <v-col cols="16">
                    There are no currency rates at the moment.
                  </v-col>
                </div>
                <!--</editor-fold>-->
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { cloneDeep } from 'lodash'
import filterableMixin from '@/mixins/filterableMixin'
import CurrencyExchangeRate from '@/models/CurrencyExchangeRate'
import CurrencyExchangeMarginRate from '@/models/CurrencyExchangeMarginRate'
import CurrencyExchangeRateRow from '@/components/settings/currencyExchangeRates/CurrencyExchangeRateRow'

export default {
    name: 'CurrencyExchangeRatesIndex',
    components: {
      CurrencyExchangeRateRow
    },
    mixins: [filterableMixin],
    data() {
      return {
        currencyExchangeRates: {
          data: [],
          loading: false
        },
        currencyExchangeMarginRates: {
          data: [],
          loading: false,
          headers: [
            { text: 'Years in Future', value: 'years_in_future', sortable: true },
            { text: 'Margin', value: 'rate', sortable: false }
          ]
        },
        filtersClean: CurrencyExchangeRate.emptyFilters,
        filtersDirty: cloneDeep(CurrencyExchangeRate.emptyFilters),
        currencyExchangeMarginRateDirty: undefined,
        currencyExchangeMarginRateEditDialog: false
      }
    },
    computed: {
      currencies() {
        return CurrencyExchangeRate.currencies
      },
      currencyExchangeHeaders() {
        return [
          { text: 'Base', value: 'base', sortable: false },
          { text: 'Quote', value: 'quote', sortable: false },
          { text: 'Market Rate', value: 'rate', sortable: false },
          { text: 'NY Rate ' + this.nextYear, value: 'rate', sortable: false },
          { text: 'Date', value: 'date', sortable: false }
        ]
      }
    },
    created() {
      this.fetchCurrencyExchangeRates()
      this.fetchCurrencyExchangeMarginRates()

      this.nextYear = (new Date().getFullYear() + 1)
    },
    methods: {
      onFiltersUpdate() {
        this.fetchCurrencyExchangeRates()
      },
      async fetchCurrencyExchangeRates() {
        this.currencyExchangeRates.loading = true

        let queryParams = {
          ...this.filterQueryParams
        }

        try {
          this.currencyExchangeRates.data = await CurrencyExchangeRate.api.fetch(queryParams)
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.currencyExchangeRates.loading = false
        }
      },
      async fetchCurrencyExchangeMarginRates() {
        this.currencyExchangeMarginRates.loading = true

        try {
          this.currencyExchangeMarginRates.data = await CurrencyExchangeMarginRate.api.fetch()
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.currencyExchangeMarginRates.loading = false
        }
      },
      clearFilters() {
        this.currencyExchangeRates.filters = cloneDeep(CurrencyExchangeRate.emptyFilters)
      }
    }
  }
</script>
